import { render, staticRenderFns } from "./LegalDocumentTask.vue?vue&type=template&id=733f3558&scoped=true&"
import script from "./LegalDocumentTask.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentTask.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentTask.vue?vue&type=style&index=0&id=733f3558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733f3558",
  null
  
)

export default component.exports